export default "__VITE_ASSET__BRxHmoX8__"